import { render, staticRenderFns } from "./SDAAlerts.vue?vue&type=template&id=4fb557ae"
import script from "./SDAAlerts.vue?vue&type=script&lang=js"
export * from "./SDAAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports